<template>
  <section class="sme-container__info">
    <template>
      <div
        class="box">
        <div
          class="table"
        >
          <div class="th font-14" >Premium</div>
          <div
            v-for="(item,sumIndex) in preimum"
            :key="sumIndex"
            class="tr"
          >
            <span class="fw-600">{{ item.item }}</span>
            <span>
              {{ item.premium|formatMoney(2, true) }}
            </span>
          </div>
        </div>
      </div>
      <div
        class="box">
        <div
          class="table commssion-table"
        >
          <div class="th font-14" >Commission Settings</div>
          <div
            v-for="(item,index) in commission"
            :key="'commission_'+index">
            <template  v-if="!['referrer_net','insurer_net'].includes(item.name)">
              <tr
                :class="{'last-tr':index==(commission.length-1)}"
                class="tr">
                <td
                  class="fw-600"
                  v-html="changeLineData(item.item)"></td>
                <td>
                  <span class="flex">
                    <!--                  <span-->
                    <!--                    v-if="item.name!='gross'"-->
                    <!--                    class="flex-1">{{item.pct}}%</span>-->
                    <span  class="flex-1">
                      {{ item.premium_str }}
                    </span>
                  </span>
                  <!--              {{ item.premium_str }}-->
                </td>
              </tr>
            </template>
            <template v-else>
              <tr  class="tr">
                <td>{{item.name=='referrer_net'?'Referrer Reward(Commission) Rate':'Insurer Commission Rate'}}</td>
                <td>
                  <span class="flex">
                    <span  class="flex-1">
                      {{ item.pct }}%
                    </span>
                  </span>
                  <!--              {{ item.premium_str }}-->
                </td>
              </tr>
              <tr
                v-if="item.name=='insurer_net'"
                class="tr">
                <td>{{item.name=='referrer_net'?'Referrer Net(with levy)':'Insurer Net(with levy)'}}</td>
                <td>{{item.premium_str}}</td>
              </tr>
            </template>
          </div>
        </div>
      </div>
      <div
        class="box">
        <div
          class="table"
        >
          <div class="th font-14" >Excess</div>
          <div
            v-for="(item,sumIndex) in excess"
            :key="'excess_'+sumIndex"
            class="tr"
          >
            <span class="fw-600">{{ item.item }}</span>
            <span>
              {{ item.content }}
            </span>
          </div>
          <div
            v-if="excess.length<=0"
            class="tr pd-b-20 pd-t-16">-</div>
        </div>
      </div>
    </template>
  </section>

</template>
<script>
import MixinOptions from '@/mixins/options'
import MixinFormat from '@/mixins/format'
export default {
  name: 'smePremiumCoverage',
  components:{
  },
  mixins: [MixinOptions,MixinFormat],
  props: {
    formData: {
      type: Object,
      default: () => ({})
    },
  },
  data(){
    return{
    }
  },
  computed: {
    preimum(){
      let {sidebar_info}=this.formData||{}
      return sidebar_info
    },
    commission(){
      let {commission}=this.formData||{}
      return commission
    },
    excess(){
      let {excess}=this.formData||{}
      return excess||[]
    },
  },
}
</script>
<style lang="scss" scoped>
@import "../../quoting/sme/info";
/deep/.upload-container{
  width: 320px!important;
  .upload-card {
    width: 320px;
    height: 150px;
  }
}
.flex-start{
  align-items: flex-start !important;
}
.marketing + .marketing{
  margin-top: 10px;
}
/deep/.commssion-table .tr{
  border-radius: 0!important;
  &.last-tr{
    border-bottom-left-radius: 6px!important;
    border-bottom-right-radius: 6px!important;
  }
}
</style>
